<template lang="pug">
div
  .notification-overlay(:class='{ open : isDropdownOpened }')
    .triangle
  ul.nav(:class='navClasses')
    li
      router-link.dropdown-toggle(to='/chat', data-toggle='dropdown')
        //- i.material-icons chat
        img(src="../../assets/images/faces/ic_chat.svg")
        //- i.fa.fa-comments
        p.hidden-lg.hidden-md Chat
    li.dropdown(:class='[(isDropdownOpened ? "open": ""), iOS() ? "fix-safari" : ""]', v-click-outside='closeDropdown')
      a.dropdown-toggle(href='#', data-toggle='dropdown', @click.prevent='openDropdown')
        i.material-icons
          img(src="../../assets/images/faces/ic_noti.svg")
        span.notification(v-if="notify")
        p.hidden-lg.hidden-md Notifications
      ul.dropdown-menu.dropdown-menu-notify
        li.li-notify(
          @click="onNotifyItem(item.id)" 
          v-for="(item, index) in lst5items" 
          :style="index === (lst5items.length - 1) ? 'border: none;': ''")
          //- a(href='#') Bạn có yêu cầu liên kết tài khoản mới từ Nguyễn Ngọc Lan
          .img-avt
            img(src="../../assets/images/faces/ic_AvatarDefault.svg")
          .content-notify(:style="item.status === 2  ? 'font-weight: bold;' : 'font-weight: normal;'")
            | {{item.short_content}}
            .date {{ item.created_at | moment }}
        .lst-all
          span(@click="onNotification") Xem tất cả
    li
      a.dropdown-toggle(href='#', data-toggle='dropdown', @click='submitLogout')
        //- i.material-icons exit_to_app
        img(src="../../assets/images/faces/ic_logout.svg")
        p.hidden-lg.hidden-md Sign out
</template>
<script>
import mdLogout from '../Account/Logout'
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import moment from 'moment'
export default {
  name: 'navbar-right',
  props: {
    mobile: Boolean
  },
  data() {
    return {
      isDropdownOpened: false,
      lstItems: [],
      lst5items: [],
      notify: false,
      intervalid: null
    }
  },
  computed: {
    navClasses() {
      return this.mobile ? ['nav-mobile-menu'] : ['navbar-nav', 'navbar-right']
    }
  },
  methods: {
    iOS() {
      var iDevices = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ]
      if (navigator.platform) {
        while (iDevices.length) {
          if (navigator.platform === iDevices.pop()) { return true }
        }
      }
      return false
    },
    openDropdown() {
      this.refreshDropdown()
      this.isDropdownOpened = !this.isDropdownOpened
    },
    closeDropdown() {
      if (this.isDropdownOpened) {
        this.isDropdownOpened = false
      }
    },
    submitLogout() {
      this.$modal.show(mdLogout, {}, {
        clickToClose: false,
        height: 'auto',
        adaptive: true,
        classes: ['col-md-6'],
        reset: true
      })
    },
    onNotification() {
      this.openDropdown()
      this.$router.push('/notifications')
    },
    refreshDropdown(limit) {
      this.notify = false
      // TODO: check lại ko cho run query này nếu token chưa claims
      if (this.$store.getters.user !== null) {
        this.$apollo.query({
          query: gql(graphql.GET_NOTIFY_USER),
          variables: {
            uid: this.$store.getters.user,
            limit: limit
          }
        }).then((response) => {
          this.lstItems = response.data.user_notification
          this.lst5items = []
          for (let i = 0; i < this.lstItems.length; i++) {
            if (this.lstItems[i].status === 2) {
              this.notify = true
              break
            }
          }
          for (let i = 0; i < this.lstItems.length; i++) {
            if (this.lst5items.length < 5) this.lst5items.push(this.lstItems[i])
          }
          // console.log(this.notify)
        })
      }
    },
    onNotifyItem(id) {
      // console.log(id)
      this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_READ_NOTIFY),
        variables: {
          id: id,
          changes: {
            status: 3
          }
        }
      }).then(data => {
        this.refreshDropdown()
      })
    }
  },
  beforeDestroy() {
    // console.log('DESTROYYYY!!!', this.intervalid)
    clearInterval(this.intervalid)
  },
  filters: {
    moment(date) {
      return moment(date).format('hh:mm DD/MM/YYYY') // format (h:mm:ss a)
    }
  },
  created() {
    this.intervalid = setInterval(() => {
      this.refreshDropdown()
    }, 900)
  },
  apollo: {
    // lstItems: {
    //   query: gql(graphql.GET_NOTIFY_USER),
    //   variables() {
    //     return {
    //       uid: this.$store.getters.user,
    //       limit: 5
    //     }
    //   },
    //   update: data => {
    //     if (data.user_notification !== null) {
    //       console.log(data.user_notification, store.getters.user)
    //       return data.user_notification
    //     }
    //     return null
    //   }
    // }
  }
}
</script>
<style lang="scss">
// .notification-overlay{display: none; position: fixed; top:0; right: 0; left: 0; bottom: 0; width: 100%; height: 100%;z-index: 99;
//   &.open{display: block; background: #000000 0% 0% no-repeat padding-box;opacity: 0.7;
//     .triangle{border-bottom: solid 15px #fff;border-left: solid 15px transparent;border-right: solid 15px transparent; top:25px; right: 35px; position: absolute;}
//   }
// }
.dropdown-menu-notify {
  width: 358px;
  li.li-notify {
    padding-bottom: 10px;
    margin: 10px 10px 15px;
    border-bottom: 1px solid #B4B4B4;
    width: calc(100% - 20px);
    &:hover {background: #9c27b0; color: white; border-radius: 5px; cursor: pointer;}
    .img-avt {
      width: 40px;
      display: inline-flex;
      float: left;
      img {max-width: 100%; height: auto; width: 100%; border-radius: 50%;}
    }
    .content-notify {
      padding-left: 5px;
      display: inline-block;
      width: calc(100% - 40px);
      // font-weight: bold;
      .date {color: #BEBEBE; font-weight: normal;}
    }
  }
  .lst-all {text-align: center; color:#1A4797;
    span:hover {text-decoration: underline; cursor: pointer;}
  }
}
@media (max-width: 991px){
  .fix-safari{margin-top: -5px;
    span.notification{margin-top:7px; }
  }
  .dropdown-toggle{
    span.notification{margin-right:-9px; }
  }
}
@media (max-width: 320px){
  .box-header-top{
    .navbar.navbar-transparent{
      .container-fluid{
        .navbar-header{
          .menu-header{
            a{padding: 10px;}
          }
        }
        .navbar-collapse{
          .navbar-nav{
            &.navbar-right{margin: 10px 0;}
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// navbar-right.vue?11af3994